<template>
  <div class="layout auth-layout">
    <!-- <a
      class="announcement-login flex flex-align-center"
      href="https://blog.ainumber.com/announcing-number/"
      target="_blank" >
      <p class="mr-1 black">Sendbee is now AI Number.</p>
      <p>Read more</p>
      <SBIcon
        class="ml-1"
        :icon="SBIconList.ARROW"
        :color="SBColors.bluePrimary"
        :size="10"
        :rotate="270" />
    </a> -->
    <router-view/>
  </div>
</template>

<script>
import '@/assets/css/modules/_login.scss';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'AuthLayout',
  components: {
    SBIcon,
  },
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
};
</script>

<style lang="scss" scoped>
.announcement-login {
  padding: 6px 11.8px 7px 14px;
  border-radius: 14px;
  border: solid 1px $greyBorder;
  background-image: linear-gradient(96deg, #fffff4, #fff7fd 31%, #f7ffff 67%, #fafffa);
  font-size: 12px;
  font-weight: 500;
  color: $bluePrimary;
  cursor: pointer;

  &:hover {
    border: solid 1px $greyLight;
    text-decoration: none;
  }
}
</style>
